<template>
  <div class="goshop">
    <div class="page-body">
      <div class="medal-area">
        <div class="area-head disFlex fc Flex-between">
          <div class="title">
            {{ goshopNow }}/{{ goshopTarget }} (已逛数量/需逛数量)
          </div>
          <div class="rule disFlex fc" @click="viewRule">
            <div>逛店规则</div>
            <div class="ask">?</div>
          </div>
        </div>
        <div class="area-body f fw">
          <div
            class="shop-item disFlex vertical fvc"
            v-for="(item, index) in shopVisitedData"
            :key="index"
          >
            <div v-if="item.goShopStatus" class="logo-box f v fc">
              <img
                src="https://j.weizan.cn/youxiang/yiguangdian.png?v=1"
                class="pic"
              />
              <img :src="item.brandLogo" class="bg" />
            </div>
            <div v-else class="logo-box f v fc">
              <img
                src="https://j.weizan.cn/youxiang/weiguangdian.png?v=2"
                class="pic"
              />
              <img :src="item.brandLogo" class="bg" />
            </div>
            <div class="brandname clamp1">{{ item.brandName }}</div>
          </div>
        </div>
      </div>
      <div class="f fvc v">
        <div class="goshop-btn" @click="toshop" v-if="isGoshop=='active'">
          去逛店
        </div>
        <div class="goshop-btn" @click="goVerify" v-if="isGoshop=='success'">
          去核销
        </div>
        <div
          class="goshop-btn"
          v-if="isGoshop=='finish'"
          @click="detailFlag = true"
        >
          查看详情
        </div>
      </div>
      <div class="f fvc v">
        <div class="back-btn" @click="backInfo">返回</div>
      </div>
    </div>
    <van-dialog
      v-model="ruleFlag"
      :close-on-click-overlay="true"
      title="逛店规则"
    >
      <pre class="pre" style="margin: 20px 20px">{{ rule }}</pre>
    </van-dialog>
    <van-dialog
      v-model="QrcodeFlag"
      :close-on-click-overlay="true"
      title="去核销"
      class="sign-show"
    >
      <img :src="qrcodimg" alt />
    </van-dialog>
    <van-dialog
      v-model="detailFlag"
      :close-on-click-overlay="true"
      title="核销详情"
    >
      <div class="f v" style="align-items: flex-start; margin: 30px 20px">
        <div>核销时间：{{ goshopDetail.finishTime }}</div>
        <div class="mt10">核销员工：{{ goshopDetail.name }}</div>
        <div class="mt10">核销品牌：{{ goshopDetail.brandName }}</div>
        <div class="mt10">核销门店：{{ goshopDetail.shopName }}</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shopVisitedData: [],
      rule: "",
      ruleFlag: false,
      QrcodeFlag: false,
      detailFlag: false,
      goshopNow: 0,
      goshopTarget: 0,
      isGoshop: "active",
      goshopDetail: {
        finishTime: "-",
        name: "-",
        brandName: "-",
        shopName: "-",
      },
      qrcodimg: "",
      timer: null,
    };
  },
  created() {
    // 需要获取逛店的已核销状态，也要获取已核销的数据
    this.getShopVisitedData();
    // this.getRule();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    async getShopVisitedData() {
      let res = await this.$http.post("/v1/finance/config/go_shop_list");
      console.log(res);
      if (res.data && res.code == 0) {
        this.shopVisitedData = res.data;
        var goshopNow = 0;
        this.shopVisitedData.forEach((item) => {
          if (item.goShopStatus) {
            goshopNow++;
          }
        });
        this.goshopNow = goshopNow;
        this.getRule();
      } else {
        this.$toast(res.msg);
      }
    },
    async getRule() {
      let res = await this.$http.post("/v1/finance/config/go_shop_rule");
      console.log(res,"1611");
      if (res.data && res.code == 0) {
        this.rule = res.data.goShopDesc;
        if (res.data.applyKpiUser) {
          var kpiObj = res.data.applyKpiUser;
          this.goshopDetail = {
            finishTime: kpiObj.finishTime ? kpiObj.finishTime : "-",
            name: kpiObj.name ? kpiObj.name : "-",
            brandName: kpiObj.brandName ? kpiObj.brandName : "-",
            shopName: kpiObj.shopName ? kpiObj.shopName : "-",
          };
        }
        this.isGoshop = res.data.status || "active";
        this.goshopTarget = res.data.goShopTimes;
        console.log(this.isGoshop);
        console.log(this.goshopTarget);
        if (this.goshopTarget == 0 && this.shopVisitedData) {
          this.goshopTarget = this.shopVisitedData.length;
        }
      } else {
        this.$toast(res.msg);
      }
    },
    viewRule() {
      this.ruleFlag = true;
    },
    backInfo() {
      this.$router.push({
        path: this.$utils.getMyPagePath(),
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    toshop() {
      this.$toast("扫码门店员工签到码即可逛店");
    },
    async goVerify() {
      clearInterval(this.timer);
      let res = await this.$http.get("/v1/qrcode/gen_code", {
        scene: "go_shop_finish",
        addition: encodeURIComponent(
          JSON.stringify({ user_id: localStorage.getItem("user_id") })
        ),
      });
      console.log(res);
      if (res.data && res.code == 0) {
        this.qrcodimg = res.data.qrcodePath;
        this.QrcodeFlag = true;
        // 此时开始轮询判断当前逛店核销状态是否已核销，是则自动刷新当前页面
        var calltime = 0;
        this.timer = setInterval(async () => {
          calltime++;
          let res = await this.$http.post("/v1/finance/config/go_shop_rule");
          if (res.data && res.code == 0) {
            if (res.data.status == "finish") {
              clearInterval(this.timer);
              // 核销成功，刷新页面
              this.$toast("核销成功");
              window.location.reload();
            }
            if (calltime >= 20) {
              this.$toast("请重新获取核销码");
              clearInterval(this.timer);
              calltime = 0;
              this.QrcodeFlag = false;
            }
          } else {
            clearInterval(this.timer);
            this.QrcodeFlag = false;
            this.$toast(res.msg);
          }
        }, 3000);
      } else {
        this.$toast(res.msg);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.goshop {
  background: #fff;
  min-height: 100vh;
  padding: 16px 16px 0;
  .medal-area {
    .area-head {
      .title {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(53, 53, 53, 1);
      }
      .rule {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(105, 105, 105, 1);
        .ask {
          font-size: 10px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(203, 151, 76, 1);
          line-height: 16px;
          text-align: center;
          width: 16px;
          height: 16px;
          background: rgba(255, 209, 143, 1);
          opacity: 0.5;
          border-radius: 8px;
          margin-left: 10px;
        }
      }
    }
    .area-body {
      padding: 16px 0;
      overflow-y: scroll;
      margin-top: 20px;
      height: 64vh;

      align-items: flex-start;
      .shop-item {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(53, 53, 53, 1);
        margin-left: 10px;
        margin-right: 10px;
        div {
          margin-top: 10px;
        }
        .brandname {
          width: 90px;
          line-height: 18px;
        }
      }
    }
  }
  .pre {
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
    font-family: PingFang SC;
    margin: 0 10px;
    text-align: left;
  }
  .logo-box {
    width: 90px;
    height: 64px;
    position: relative;
    overflow: hidden;
    .bg {
      width: 85px;
      height: 43px;
    }
    .pic {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 100;
      width: 90px;
      height: 64px;
    }
  }
  .back-btn {
    width: 315px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(0, 48, 120, 1);
    line-height: 44px;
    text-align: center;
    position: fixed;
    bottom: 26px;
    background: #fff;
  }
  .goshop-btn {
    width: 315px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #fff;
    line-height: 44px;
    text-align: center;
    position: fixed;
    bottom: 86px;
    background: rgba(0, 48, 120, 1);
  }
  .sign-show {
    /*业主签到弹框*/
    img {
      width: 260px;
      height: 260px;
      vertical-align: bottom;
      margin: 20px 0;
    }
  }
}
</style>